{
  "entity": "Receipt request",
  "create": "Create receipt request",
  "edit": "Edit receipt request",
  "detail": "Receipt request details",
  "info": "Receipt request information",
  "request_no": "Receipt number",
  "name": "Receipt name",
  "payer": "Payer",
  "payee": "Payee",
  "payer_account": "Payer account",
  "payee_account": "Payee account",
  "payment_item": "Payment item",
  "currency": "Receivable currency",
  "receivable_amount": "Receivable amount",
  "received_amount": "Received amount",
  "pending_amount": "Pending amount",
  "received_pending": "Received / pending",
  "status": "Status",
  "created_by": "Created by",
  "created_at": "Created at",
  "business_object": "Business object",
  "vehicle": "Vehicle",
  "non_vehicle": "Non-vehicle",
  "description": "Business description",
  "non_vehicle_description": "Non-vehicle business description",
  "vehicles": "Vehicle items",
  "vehicle_list": "Receipt request vehicle items",
  "brand": "Brand",
  "model": "Model",
  "vin": "VIN",
  "quantity": "Quantity",
  "unit_amount": "Amount",
  "total": "Total",
  "remark": "Remark",
  "attachments": "Attachments",
  "customer_slips": "Customer payment slips",
  "upload": "Upload attachments",
  "upload_hint": "Any file type; multiple files supported",
  "history": "Receipt history",
  "history_empty": "No receipt history",
  "close": "Close",
  "modify": "Edit",
  "remove": "Delete",
  "save_draft": "Save draft",
  "submit": "Submit request",
  "save_success": "Saved successfully",
  "submit_success": "Submitted successfully",
  "delete_success": "Deleted successfully",
  "query_placeholder": "Receipt number / name / payee / payer",
  "disabled_tip": "This request is {{status}}. Only draft or not received requests can be changed.",
  "delete_confirm": "Delete “{{number}}”?",
  "missing_id": "Receipt request ID is missing",
  "missing_fund": "Fund transaction ID is missing",
  "required": "Enter {{field}}",
  "choose": "Select {{field}}",
  "partner_placeholder": "Enter or select {{field}}",
  "max_length": "{{field}} must not exceed {{max}} characters",
  "at_least_one": "Add at least one vehicle",
  "amount_warning": "The vehicle total differs from the receivable amount. Drafts may be saved; submission requires the vehicle total.",
  "correction_title": "Vehicle total differs from the receivable amount",
  "correction_content": "Adjust the receivable amount to the vehicle total of {{amount}} {{currency}} and submit?",
  "correction_confirm": "Adjust and submit",
  "invalid_amount": "Amount must be non-negative with at most two decimal places",
  "invalid_total": "Receivable amount must be positive and within the safe amount range",
  "invalid_vin": "VIN must contain 17 letters or digits, excluding I, O and Q",
  "duplicate_vin": "Duplicate VIN on row {{row}}",
  "invalid_quantity": "Quantity must be 1 for each vehicle",
  "confirm_receipt": "Confirm receipt",
  "settlement_voucher": "Receipt voucher",
  "upload_voucher": "Upload receipt voucher",
  "zero_pending": "No amount remains to receive. You can confirm receipt.",
  "workflow_description": "Show receipt request details and record settlements at the confirmation step",
  "draft": "Draft",
  "receiving": "Receiving",
  "fully_received": "Fully received",
  "partially_received": "Partially received",
  "not_received": "Not received"
}
